"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Standards() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const sensoryNotes = [{
    lead: "Precision",
    body: "Refined facial balancing that respects your unique anatomy, ensuring results that look entirely like you."
  }, {
    lead: "Privacy",
    body: "A concierge experience delivered in the comfort of your own space, removing the stress of clinical waiting rooms."
  }, {
    lead: "Prevention",
    body: "Strategic use of fillers and neuromodulators to soften lines early, preserving your natural radiance for years to come."
  }];
  return <section data-section-id="9801" id="luxury-standards" className="dark bg-background text-foreground py-24 md:py-40 px-6 md:px-12">
      <div className="max-w-[1320px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          {}
          <div ref={textRef} className="md:col-span-6 md:order-2 max-w-[480px] mx-auto md:mx-0" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateY(0)" : "translateY(12px)",
          transition: "opacity 700ms cubic-bezier(0.22, 0.61, 0.36, 1), transform 700ms cubic-bezier(0.22, 0.61, 0.36, 1)"
        }}>
            <p className="font-default uppercase mb-8" style={{
            color: "var(--muted-foreground)",
            fontSize: "clamp(0.78rem, 0.85vw, 0.875rem)",
            fontWeight: 500,
            letterSpacing: "0.14em",
            lineHeight: 1.2
          }}>
              Our philosophy
            </p>

            <h2 className="font-default text-foreground mb-10" style={{
            fontSize: "clamp(2rem, 3.6vw, 3.25rem)",
            fontWeight: 400,
            letterSpacing: "-0.018em",
            lineHeight: 1.1
          }}>
              Refinement you can{" "}
              <span className="relative inline-block italic" style={{
              fontStyle: "italic",
              fontWeight: 400
            }}>
                trust
                <span aria-hidden="true" className="absolute left-0 right-0" style={{
                bottom: "0.08em",
                height: "2px",
                backgroundColor: "var(--primary)",
                opacity: 0.85
              }} />
              </span>
              .
            </h2>

            <div className="space-y-7 mb-12">
              {sensoryNotes.map((note, i) => <p key={i} data-index={i} className="font-default" style={{
              color: "var(--muted-foreground)",
              fontSize: "clamp(1.05rem, 1.2vw, 1.2rem)",
              fontWeight: 380,
              lineHeight: 1.65
            }}>
                  <span className="font-default text-foreground" style={{
                fontWeight: 500,
                letterSpacing: "-0.005em"
              }}>
                    {note.lead}
                  </span>
                  <span className="text-foreground/60">{" — "}</span>
                  {note.body}
                </p>)}
            </div>

            <Link to="/ExperiencePage">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg font-default" style={{
              height: "auto",
              paddingLeft: "1.75rem",
              paddingRight: "1.75rem",
              paddingTop: "0.875rem",
              paddingBottom: "0.875rem",
              fontWeight: 500,
              fontSize: "1rem",
              letterSpacing: "0.005em",
              transitionDuration: "280ms",
              transitionTimingFunction: "ease-out"
            }}>
                Explore our approach
              </Button>
            </Link>
          </div>

          {}
          <div ref={imageRef} className="md:col-span-6 md:order-1">
            <div className="relative overflow-hidden rounded-lg w-full" style={{
            aspectRatio: "4 / 5",
            boxShadow: "var(--shadow-2xl)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_consultation_room.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_consultation_room.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_consultation_room.webp-wvc-sizes" alt="A serene, minimalist aesthetic consultation space with soft lighting" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" style={{
              opacity: imageVisible ? 1 : 0,
              transform: imageVisible ? "scale(1)" : "scale(1.06)",
              transition: "opacity 900ms ease-out, transform 900ms ease-out"
            }} />
            </div>
          </div>
        </div>
      </div>
    </section>;
}